import { defineStore } from 'pinia';
import { ApiKey, fetchApi, FetchApiOrigin } from "~/common/API/baseApi";

interface ICity {
  id: number;
  ru: string;
  en: string;
}

interface ICountry {
  id: number;
  cities: ICity[];
  alpha2: string;
  alpha3: string;
  ru: string;
  en: string;
}

export const useAppStore = defineStore('app', () => {
  const interests = ref<{ id: number, name: string }[]>([]);
  const showSupportChatModal = ref<boolean>(false);
  const geo = ref<ICountry[]>([]);


  // Получаем все интересы из бд
  (async () => {
    if (interests.value.length > 0) return;
    try {
      const endpoint = '/place/interests';
      const response: any = await fetchApi({
        endpoint,
        origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      });
      interests.value = response.interests;
    } catch (err) {
      console.error(err);
    }
  })();

  // Получаем Гео из бд
  (async () => {
    if (geo.value.length > 0) return;
    try {
      const endpoint = '/geo/countries';
      const response: any = await fetchApi({
        endpoint,
        origin: FetchApiOrigin.LIGHT_API_ORIGIN,
      });
      geo.value = response.records;
    } catch (err) {
      console.error(err);
    }
  })();

  return {
    interests,
    showSupportChatModal,
    geo,
  }
});